import { Link } from 'react-router-dom';
import { statsData, features } from '@/mocks/testimonials';

export default function Stats() {
  return (
    <section className="w-full bg-accent-100/70 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block px-4 py-1.5 rounded-full bg-background-50 text-foreground-700 text-xs font-label font-medium mb-6">
            值得信赖的韩漫平台
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-black text-foreground-950 leading-tight">
            为什么选择
            <br />
            韩国漫画网
          </h2>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12 mb-14 md:mb-20">
          {features.map((feature) => (
            <div key={feature} className="text-center">
              <p className="text-sm md:text-base text-foreground-600 font-label">
                {feature}
              </p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
          {statsData.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="flex items-baseline justify-center gap-1 mb-2">
                <span className="text-3xl md:text-5xl font-heading font-black text-primary-700">
                  {stat.value}
                </span>
                <span className="text-base md:text-lg text-foreground-600 font-label">
                  {stat.suffix}
                </span>
              </div>
              <p className="text-xs md:text-sm text-foreground-500 font-label">
                {stat.label}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-14 md:mt-20">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-label font-semibold cursor-pointer hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            了解更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}